import styled from 'styled-components';
import { centerAligned } from '@medly-components/utils';
import { sectionWrapperStyles } from '../WelcomeToMaps.styled';
import { Box } from '@medly-components/core';

export const Container = styled(Box)`
    ${sectionWrapperStyles}
    padding: 4.8rem 4rem;
    background-color: ${({ theme }) => theme.colors.grey[300]};
    display: flex;
    align-items: center;
    gap: 2.4rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        flex-direction: column;
        gap: 4rem;
        padding: 1.6rem;
        align-items: baseline;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    flex: 100%;
    color: ${({ theme }) => theme.colors.darkBlue};

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        padding: 0.8rem;
        gap: 0.8rem;
    }
`;

export const VideoWrapper = styled.div`
    width: 100%;
    flex: 100%;
    ${centerAligned('flex')}

    & > * {
        width: 100%;
        aspect-ratio: 103 / 58;
    }
`;
